import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import ReactCodeInput from 'react-code-input';

// Single owner of the react-code-input quirks: the package provides no way
// to clear its value, so reset() remounts it through a changing key.
const OtpCodeInput = forwardRef(function OtpCodeInput(props, ref) {
  const { fields = 6, disabled, onChange, value = '', label } = props;
  const [code, setCode] = useState(value);
  const [inputKey, setInputKey] = useState(0);
  const groupRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      setCode('');
      setInputKey(previousKey => previousKey + 1);
    },
  }));

  useEffect(() => {
    if (value !== code) {
      setCode(value);
      setInputKey(previousKey => previousKey + 1);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // react-code-input hardcodes autocomplete="off" and forwards no aria.
    const inputs = groupRef.current?.querySelectorAll('input') || [];
    inputs.forEach((input, index) => {
      input.setAttribute('aria-label', `${label} ${index + 1} / ${fields}`);
      input.setAttribute('autocomplete', index === 0 ? 'one-time-code' : 'off');
    });
  }, [fields, inputKey, label]);

  const handleChange = newValue => {
    setCode(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div
      ref={groupRef}
      role="group"
      aria-label={label}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <ReactCodeInput
        // "number" is the only type that makes the package enforce digits;
        // "text"/"tel" accept letters. Spinners are dropped in index.css.
        type="number"
        inputMode="numeric"
        fields={fields}
        onChange={handleChange}
        value={code}
        className="otp-input"
        disabled={disabled}
        key={inputKey}
      />
    </div>
  );
});

export default OtpCodeInput;
